<div *ngIf="enableLoader" id="loader"></div>
<cx-storefront *ngIf="!enableLoader"></cx-storefront>